import type * as React from 'react';
import { tss } from 'tss-react/mui';
import { H2 } from '../H2';

const useFilterDialogContainerStyles = tss.create({
    filterFieldsContainer: {
        padding: 5,
    },
});

export default function FilterDialogContainer({
    title,
    children,
}: {
    title: React.ReactNode;
    children: React.ReactNode;
}) {
    const { classes } = useFilterDialogContainerStyles();
    return (
        <section>
            <H2>{title}</H2>
            <div className={classes.filterFieldsContainer}>{children}</div>
        </section>
    );
}
